export default __webpack_public_path__ + "static/MediaMainBannerFallback-e1af7bc64611ae9f46e27ca293c94d95.png";